enum Feature {
    testFeatureFlag = 'testFeatureFlag',
    intentPage3026 = 'intentPage3026',
    contribution4244 = 'contribution4244',
    lead3487 = 'lead3487',
    verified3080 = 'verified3080',
    intentBuilder3266 = 'intentBuilder3266',
    howDidYouHear3406 = 'howDidYouHear3406',
    prosper3600 = 'prosper3600',
    leadForm3845 = 'leadForm3845',
    dailyPremium3972 = 'dailyPremium3972',
    newLandingPage4050 = 'newLandingPage4050',
    mqlExperienceMetaTraffic4198 = 'mqlExperienceMetaTraffic4198',
    consent4580 = 'consent4580',
    stickyCTA4274 = 'stickyCTA4274',
    premiumRange4380 = 'premiumRange4380',
    featureDefault4362 = 'featureDefault4362',
    newQuotesPage4452 = 'newQuotesPage4452',
    intentBuilder4456 = 'intentBuilder4456',
    newWalkthrough4593 = 'newWalkthrough4593',
    // someFeature = 'someFeature',
}

export default Feature;
